import React from 'react'

function Branding() {
  return (
  <section className="bg-gray-100">
    <div className="max-w-screen-xl	mx-auto text-center">
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
        <div className="w-full flex flex-col justify-center items-center">
          <div className="content px-20">
            <p className="text-left font-bold text-2xl">
              Branding
            </p>
            <p className="text-left text-lg text-gray-600">
              As part of a start-up company, one of the main tasks I had to do is to start with the Brand logo, colors, typography. From the name itself - SeeYouDoc or "See you, doc" means like visiting a doctor anytime soon, we find words that connect patients and doctors. The goal of the brand is to identify as caring, innovative, and affordable.
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-between items-center">
          <img src={require('../../common/images/seeyoudoc/heart.svg')} alt="Heart Art"/>
          <div className="text-left">
            <p className="font-bold">Heart</p>
            <p className="text-sm text-gray-500">Health, Caring</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="pr-5">
            <p className="text-blue-600 text-xl font-bold">+</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-between items-center">
          <img src={require('../../common/images/seeyoudoc/stethoscope.svg')} alt="Stethoscope Art" />
          <div className="text-left">
            <p className="font-bold">Stethoscope</p>
            <p className="text-sm text-gray-500">Medical Doctor</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="pr-5">
            <p className="text-blue-600 text-xl font-bold">+</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-between items-center">
          <img src={require('../../common/images/seeyoudoc/circuit.svg')} alt="Circuit Art"/>
          <div className="text-left">
            <p className="font-bold">Circuit</p>
            <p className="text-sm text-gray-500">Innovation, Technical</p>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/seeyoudoc/syd-white-bg.svg')} alt="SeeYouDoc Logo White BG Art"/>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/seeyoudoc/syd-blue-bg.svg')} alt="SeeYouDoc Logo Blue BG Art"/>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/seeyoudoc/syd-grids.svg')} alt="SeeYouDoc Logo Grid Art"/>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/2 md:w-1/2 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/seeyoudoc/font-1.png')} alt="Font Art"/>
          </div>
        </div>
          <div className="lg:w-1/2 md:w-1/2 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/seeyoudoc/font-2.png')} alt="Font Art"/>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="w-full flex flex-row justify-center items-center">
          <img src={require('../../common/images/seeyoudoc/color-scheme.svg')} alt="Color Scheme Art"/>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Branding
